<template>
  <div>
    <!-- Contractor Menu -->
    <v-navigation-drawer v-if="isLoggedIn" v-model="drawer" temporary right fixed>
      <v-list v-if="$store.getters.isContractor">
        <v-list-item :to="{ name: 'CoachingOneOnOneSubscription', params: { coachId: userId } }">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="`/tasks-dashboard`">
          <v-list-item-action>
            <v-icon>mdi-calendar-text-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Task dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Standard Menu -->
      <v-list v-else>
        <v-list-item :to="{ name: 'CoachingOneOnOneSubscription', params: { coachId: userId } }">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group prepend-icon="mdi-calendar-check">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Tasks</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- <v-list-item :to="`/tasks/${userId}`">
            <v-list-item-action>
              <v-icon>mdi-calendar-text-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Task dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item :to="`/tasks-dashboard`">
            <v-list-item-action>
              <v-icon>mdi-calendar-text-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Task dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="`/support/tasks/${userId}`">
            <v-list-item-action>
              <v-icon>mdi-clipboard-list</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Support dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/users/tasks">
            <v-list-item-action>
              <v-icon>mdi-cards-club</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Club summary</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/tasks">
            <v-list-item-action>
              <v-icon>mdi-calendar-check</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Task summary</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item to="/reporting/engagement/coaching">
          <v-list-item-action>
            <v-icon>account_circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Coaches</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/deals">
          <v-list-item-action>
            <v-icon>money</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Deals</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/clients/">
          <v-list-item-action>
            <v-icon>mdi-contacts</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group prepend-icon="mdi-account-cash">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Billing</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/operations/billing/payments">
            <v-list-item-action>
              <v-icon>mdi-cash</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Payments</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/operations/billing/upcoming-payments">
            <v-list-item-action>
              <v-icon>mdi-cash</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Upcoming Payments</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group prepend-icon="group_work">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Coaching</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/coaching/clients/history">
            <v-list-item-icon>
              <v-icon>mdi-account-supervisor-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Client history</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="teamLead" to="/leads-dashboard">
            <v-list-item-action>
              <v-icon>mdi-account-supervisor-circle</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>My Coaches</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group prepend-icon="group_work">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Onboarding</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-group sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>One on one</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item to="/operations/onboarding/one-on-one">
              <v-list-item-icon>
                <v-icon>mdi-account-supervisor-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Coaching onboarding</v-list-item-title>
            </v-list-item>
            <v-list-item to="/onboarding/summary">
              <v-list-item-action>
                <v-icon>timeline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Onboarding Overview</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/operations/onboarding/priority">
              <v-list-item-icon>
                <v-icon>mdi-account-supervisor-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Priority Onboarding</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Life </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item to="/operations/onboarding/life">
              <v-list-item-icon>
                <v-icon>mdi-account-supervisor-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Onboarding</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-group>
        <v-list-group prepend-icon="mdi-chart-timeline-variant-shimmer">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Reporting</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/reporting/company">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Dashboards</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/billing">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Billing </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/deals/company">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Deals </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/engagement/summary">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Engagement</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/programs">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Programs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/groups">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Groups</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/compliance/summary">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Compliance</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/tasks">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Tasks</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/survey-results">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Survey results</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/corporate">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Corporate</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/reporting/capacity-planning">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Capacity Planning</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="superUser" to="/reporting/export">
            <v-list-item-action>
              <v-icon>mdi-pillar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Export User Lists</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item to="/social/posts/">
          <v-list-item-action>
            <v-icon>comment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Posts</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group prepend-icon="mdi-message-text">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Chats</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/chats">
            <v-list-item-action>
              <v-icon>mdi-message-text</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Overview</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="superUser" to="/chats/bulk-messages">
            <v-list-item-action>
              <v-icon>mdi-message-text</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Bulk Messages</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item v-if="teamLead || superUser" to="/admin/badge">
          <v-list-item-action>
            <v-icon>mdi-security</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Admin</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/account/profile">
          <v-list-item-action>
            <v-icon>account_box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app light height="45" align="center" justify="center">
      <v-toolbar-title>
        <a href="/">
          <v-img alt="Logo" class="shrink" contain min-width="80" src="@/assets/logo.png" width="80" />
        </a>
      </v-toolbar-title>
      <v-spacer />
      <v-btn v-if="isLoggedIn" rounded :outlined="true" @click.stop="drawer = !drawer">
        menu
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { decodeId } from "@/lib/string";
export default {
  name: "NavBar",
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    user() {
      return this.$store.getters.user;
    },
    userId() {
      return decodeId(this.$store.getters.user.id);
    },
    teamLead() {
      return this.$store.getters.user.teamLead?.length > 0;
    },
    superUser() {
      return this.$store.getters.user.isSuperuser;
    },
  },
  methods: {
    logout() {
      this.drawer = false;
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>
